(function ($, Drupal, drupalSettings, window) {
  "use strict";

  $(document).ready(function () {
    // Re-attache les behaviors lorsqu'on a une definition pro
    if ($('a[href*="/definition-pro/"]').length > 0) {
      Drupal.attachBehaviors(document, drupalSettings);
    }
  });

  //**Gestion accordion de point de services pro */
  Drupal.behaviors.servicePointsProAccordion = {
    attach: function (context) {

      if ($(".service_points_accordeons_pro", context).length) {
        // Ajouter la classe "collapsed" à tous les boutons d'accordéon
        $(".btn.btn-link.accordion", context).addClass("collapsed");

        // Ajouter les classes manquantes aux éléments correspondants
        $(context)
          .find(".row-contents > div")
          .once("ui-accordion--1")
          .each(function () {
            $(this).addClass("views-row wp-block-accordion-accordion-block");
          });

        // Fermer tous les contenus de l'accordéon
        $(".wp-block-accordion-accordion-block .row-contents", context).hide();

        $(context)
          .find(".row-contents .row-contents > div")
          .once("ui-accordion--2")
          .each(function () {
            $(this).removeClass("wp-block-accordion-accordion-block");
          });

        // Comportement de clic pour les boutons d'accordéon
        $(
          ".row-contents > .views-row .btn.btn-link.accordion",
          context
        )
          .once("ui-accordion--3")
          .click(function () {
            $(this).toggleClass("collapsed");
            $(this).attr(
              "aria-expanded",
              $(this).hasClass("collapsed") ? "false" : "true"
            );

            // Fermer les autres boutons d'accordéon
            $(
              ".wp-block-accordion-accordion-block .btn.btn-link.accordion",
              context
            )
              .not($(this))
              .addClass("collapsed")
              .attr("aria-expanded", "false");

            // Fermer les autres contenus
            var $content = $(this).parents(".header").next();
            $(".wp-block-accordion-accordion-block .row-contents", context)
              .not($content)
              .slideUp(400);

            // Basculer le contenu actuel
            $content.slideToggle(400);
          });
      }
    }
  };

  // Ajuster la hauteur des cardes d'evenements de Carrieres Pro
  Drupal.behaviors.adjustSlickSliderEvenementsCarrieresProHeight = {
    attach: function (context, settings) {

      // Appeler adjustSlickSliderEvenementsCarrieresProHeight après que le slider soit chargé
      $(window).on('load', function () {
        if ($('.evenements-de-carrieres-pro').length > 0) {
          adjustSlickSliderEvenementsCarrieresProHeight();
        }
      });

      // Également ajuster la hauteur lors du redimensionnement de la fenêtre pour maintenir la responsivité
      $(window).resize(function () {
        if ($('.evenements-de-carrieres-pro').length > 0) {
          adjustSlickSliderEvenementsCarrieresProHeight();
          //console.log('adjustSlickSliderEvenementsCarrieresProHeight');
        }
      });

      // Fonction pour ajuster la hauteur evenements de carrieres pro
      function adjustSlickSliderEvenementsCarrieresProHeight() {
        // Réinitialiser la hauteur de tous les slides
        jQuery('.evenements-de-carrieres-pro .slick__slide').height('auto');

        var maxTotalHeight = 0;

        // Trouver le slide avec la hauteur maximale (y compris le line-height)
        jQuery('.evenements-de-carrieres-pro .slick-slide').each(function () {
          var $slide = jQuery(this);
          var slideHeight = $slide.height();
          var lineHeight = parseInt($slide.css('line-height'), 10);

          // Si le line-height est défini, ajoutez-le à la hauteur du slide
          if (!isNaN(lineHeight)) {
            slideHeight += lineHeight;
          }

          // Mettre à jour la hauteur maximale
          if (slideHeight > maxTotalHeight) {
            maxTotalHeight = slideHeight;
          }
        });

        // Appliquer cette hauteur maximale à tous les slides
        jQuery('.evenements-de-carrieres-pro .slick__slide').height(maxTotalHeight);
      }

    }
  };


  // Rupture de stock - Statut de vérification (en format Définition)
  Drupal.behaviors.statutVerification = {
    attach: function (context, settings) {
      $(context).find(".status-verification-modale").once('statut-verification').each(function () {
        // Injecte le lien
        $(this).html(
          '<a href="/fr/definition-pro/liste-statuts-verification" ' +
          'class="use-ajax" ' +
          'data-dialog-type="colorbox" ' +
          'data-dialog-options=\'{"width":300,"dialogClass":"ng-ramq"}\'>' +
          'Statut de vérification<span class="sr-only">-Définition</span></a>'
        );

        //Réattacher les comportements Drupal (dont use-ajax)
        Drupal.attachBehaviors(this, settings);
      });
    }
  };

  // Rupture de stock - Rendre la loupe cliquable dans la zone de recherche + Touche ENTRER du clavier
  Drupal.behaviors.loupeSearch = {
    attach: function (context, settings) {

      $('input[name="combine_1"]', context).once('loupeSearch').each(function () {
        // Vérifier si la loupe existe déjà
        if ($(this).next('.loupe').length === 0) {
          $(this).after('<span class="loupe"></span>');
        }

        // Gestion de la touche Enter dans le champ texte
        $(this).on('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            // Simuler le clic sur le bouton Apply dont l'ID commence par "submit-ruptures-de-stock-confirmees"
            $('input[id^="edit-submit-ruptures-de-stock-confirmees"]', context)
              .first()
              .trigger('click');
          }
        });
      });

      // Gestion du clic sur la loupe
      $(document, context).once('loupeClick').on('click', '.loupe', function () {
        // Simuler le clic sur le bouton Apply
        $('input[id^="edit-submit-ruptures-de-stock-confirmees"]', context)
          .first()
          .trigger('click');
      });

    }
  };

  // Rupture de stock - Déclencher le click dès que le choix est fait dans STATUT
  Drupal.behaviors.selectChangeApply = {
    attach: function (context, settings) {

      // Cibler le select de façon stable via data-drupal-selector
      $('select[data-drupal-selector="edit-field-date-de-publication-fin-rs-value"]', context)
        .once('selectChangeApply')
        .on('change', function () {
          // Simuler le click sur le bouton Apply dont l'ID commence par "submit-ruptures-de-stock-confirmees"
          $('input[id^="edit-submit-ruptures-de-stock-confirmees"]', context)
            .first()
            .trigger('click');
        });

    }
  };

  // Rupture de stock - Ajouter la classe container aux 2 tableaux confirmé(avec filtre) et signalé
  Drupal.behaviors.ajoutClasseContainerAjax = {
    attach: function (context, settings) {
      $('.block-des-ruptures-confirmees, .block-des-ruptures-signalees', context).addClass('container');
      // Réappliquer après chaque requête AJAX (global)
      if (!$(document).data('ajoutClasseContainerBound')) {
        $(document).on('ajaxComplete.ajoutClasseContainer', function () {
          $('.block-des-ruptures-confirmees').addClass('container');
          $('.block-des-ruptures-signalees').addClass('container');
        });
        $(document).data('ajoutClasseContainerBound', true);
      }
    }
  };

  // Remplacer '-Tout-' par 'Tous' dans le filtre
  Drupal.behaviors.changeSelectText = {
    attach: function (context, settings) {
      // Cibler par l'attribut name au lieu de l'id
      $('select[name="field_date_de_publication_fin_rs_value"] option[value="All"]', context)
        .once('changeText')
        .each(function () {
          $(this).text('Tous');
        });

      // Rafraîchir Chosen s'il est appliqué sur ce select
      $('select[name="field_date_de_publication_fin_rs_value"]', context).trigger("chosen:updated");
    }
  };

  // Cacher Page 1 de 1 dans le tableau des ruptures signalées
  Drupal.behaviors.hideSinglePagePager = {
    attach: function (context, settings) {
      $('.pager-navigation-footer', context).once('hideSinglePagePager').each(function () {
        var text = $(this).text().trim();
        if (text === "Page 1 de 1") {
          $(this).hide();
        }
      });
    }
  };

  // Permet de rendre cliquable toute la cellule d’en-tête pour activer le tri
  Drupal.behaviors.clickableTableHeader = {
    attach: function (context, settings) {
      $('th.views-field-field-date-de-publication-avis-r, th.views-field-field-date-de-publication-fin-rs, th.views-field-field-date-de-statut-rs, th.views-field-field-denomination-commune', context)
        .once('clickable-th')
        .each(function () {
          const $th = $(this);
          const $link = $th.find('a').first();

          if ($link.length) {
            $th.css('cursor', 'pointer');

            $th.on('click', function (e) {
              // Si on clique ailleurs que sur le lien, on simule un vrai clic sur le <a>
              if (!$(e.target).is('a')) {
                e.preventDefault();
                e.stopPropagation();
                $link.trigger('click'); //Simule le clic AJAX du tri
              }
            });
          }
        });
    }
  };

  //Margin entre l'encadré et le tableau
  Drupal.behaviors.marginBottomIfEncadre = {
    attach: function (context, settings) {
      $('.wp-block-group.contenu-page.gutenberg-fix-processed', context).once('marginBottomIfEncadre').each(function () {
        if ($(this).find('.encadre_ruptures_stock').length > 0) {
          $(this).css('margin-bottom', '32px');
        }
      });
    }
  };


    /**
     *
     * Manuel des professionnels
     *
     */

    // --- Écouteur global pour la communication avec l'iframe ---
    if (!window.ramqIframeListenerAdded) {
      window.addEventListener('message', function (e) {
        const iframe = document.getElementById('manuel-iframe');
        if (!iframe) return;

        if (e.data.type === 'setHeight') {
          // Defer the height change to avoid blocking the main thread with a
          // synchronous re-layout triggered by the postMessage handler.
          const h = e.data.height;
          requestAnimationFrame(() => {
            iframe.style.height = (h + 120) + 'px';
          });
        }

        if (e.data.type === 'scrollToPosition') {
          const scrollBehavior = window.innerWidth < 992 ? 'auto' : 'smooth';
          // Debounce: cancel any pending scroll from a previous rapid click before
          // scheduling a new one. Without this, N rapid TOC clicks queue N overlapping
          // smooth-scroll animations that each trigger IntersectionObserver recomputation
          // on the large iframe DOM, causing sustained 200-300ms tasks for several seconds.
          clearTimeout(window.ramqScrollTimer);
          window.ramqScrollTimer = setTimeout(() => {
            const absoluteY = window.pageYOffset + iframe.getBoundingClientRect().top + e.data.offset;
            window.scrollTo({ top: absoluteY - 100, behavior: scrollBehavior });
          }, 300);
        }
      });
      window.ramqIframeListenerAdded = true;
    }

    // Ajouter le bouton d'affichage du menu des manuel pro
    // et déplacer icône "backtotop" si on est dans une page de manuel
    Drupal.behaviors.boutonMenuManuel = {
      attach: function (context) {
        if ($(".manuel-des-professionnels__field-manuel-html", context).length) {
          $("#ramq-breadcrumbs", context)
            .once("bouton-menu")
            .each(function () {
              $("#ramq-breadcrumbs", context).append(
                '<button id="btn-menu" class="btn btn-primary" type="button" data-bs-target="#menuManuel" aria-controls="menuManuel">' +
                'Table des matières' +
                '</button>'
              );
            });

          $("#backtotop", context)
            .once("fleche-top")
            .each(function () {
              $("#backtotop", context).css("bottom", "110px");
            });

          // Initialisation de l'iframe et gestion de l'URL directe
          const iframe = document.getElementById('manuel-iframe');
          if (iframe) {
            iframe.addEventListener('load', function () {
              iframe.contentWindow.postMessage({ type: 'requestHeight' }, '*');
              if (window.location.hash) {
                setTimeout(() => {
                  iframe.contentWindow.postMessage({ type: 'getOffset', target: window.location.hash }, '*');
                }, 600);
              }
            });
          }
        }
      }
    };

    // Gérer le bouton d'ouverture du menu manuel avec le clavier
    Drupal.behaviors.menuManuelKeyboardSupport = {
      attach: function (context) {
        var $btnMenu = $("#btn-menu", context).once("btn-menu-accessibility");

        if ($btnMenu.length && $("#menuManuel").length) {
          var myOffcanvas = document.getElementById("menuManuel");
          var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);

          $btnMenu.on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            bsOffcanvas.toggle();
          });

          $btnMenu.on("keydown", function (e) {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              bsOffcanvas.toggle();
            }
          });
        }
      }
    };

    // Focus après la fermeture du menu
    Drupal.behaviors.focusAfterOffcanvasClose = {
      attach: function (context) {
        const menuEl = document.getElementById("menuManuel");
        if (!menuEl) return;

        once("focus-after-close-v4", "#menuManuel", context).forEach(() => {
          menuEl.addEventListener("hidden.bs.offcanvas", () => {
            if (window._ramqIframeTargetClicked) {
              window._ramqIframeTargetClicked = false;

              // Le avisamos al iframe que ya puede aplicar el foco al ancla
              const iframe = document.getElementById("manuel-iframe");
              if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage({ type: "focusLastAnchor" }, "*");
              }
              return;
            }

            const btnMenu = document.getElementById("btn-menu");
            if (btnMenu) btnMenu.focus({ preventScroll: true });
          });
        });
      }
    };

    /**
     * Sous-menu horizontal (off-canvas) pour le manuel.
     */
    Drupal.behaviors.menuManuelSlide = {
      attach(context) {
        once('menu-manuel-slide', '#menuManuel', context).forEach((offcanvas) => {
          const container = offcanvas.querySelector('#menuManuelContent');
          if (!container) return;

          let mmcContainer = container.querySelector('.mmc-container');
          let panelNiveau1, panelNiveau2, mainNav;
          let activeToggleLink = null;
          let lastScrollPosition = 0;

          function ensureStructure() {
            mmcContainer = container.querySelector('.mmc-container');
            if (mmcContainer) {
              panelNiveau1 = mmcContainer.querySelector('.mmc-panel--niveau1');
              panelNiveau2 = mmcContainer.querySelector('.mmc-panel--niveau2');
              mainNav = panelNiveau1 ? panelNiveau1.querySelector('#nav') : null;
              container.classList.add('mmc');
              setHeightTo(panelNiveau1);
              return Boolean(panelNiveau1 && panelNiveau2 && mainNav);
            }

            mainNav = container.querySelector('#nav');
            if (!mainNav) return false;

            // Cela permet d'afficher la flèche bleue et d'activer le slide
            Array.from(mainNav.children).forEach(function (li) {
              const link = Array.from(li.children).find(function (child) {
                return child.tagName === 'A';
              });

              const subMenu = Array.from(li.children).find(function (child) {
                return child.tagName === 'UL';
              });

              if (link && subMenu) {
                link.classList.add('toggle-menu');
              }
            });

            container.classList.add('mmc');

            mmcContainer = document.createElement('div');
            mmcContainer.className = 'mmc-container';

            panelNiveau1 = document.createElement('div');
            panelNiveau1.className = 'mmc-panel mmc-panel--niveau1';
            panelNiveau1.appendChild(mainNav);

            panelNiveau2 = document.createElement('div');
            panelNiveau2.className = 'mmc-panel mmc-panel--niveau2';
            panelNiveau2.setAttribute('aria-hidden', 'true');

            container.innerHTML = '';
            container.appendChild(mmcContainer);
            mmcContainer.appendChild(panelNiveau1);
            mmcContainer.appendChild(panelNiveau2);

            setHeightTo(panelNiveau1);
            return true;
          }

          function getExtraSpace() {
            let extra = 0;
            const searchBox = container.querySelector('.recherche-interne');
            if (searchBox) {
              const style = window.getComputedStyle(searchBox);
              extra += searchBox.offsetHeight + parseFloat(style.marginTop || 0) + parseFloat(style.marginBottom || 0);
            }
            const cStyle = window.getComputedStyle(container);
            extra += parseFloat(cStyle.paddingTop || 0) + parseFloat(cStyle.paddingBottom || 0);

            return extra;
          }

          function lockHeightToMax() {
            // On libère la hauteur pour mesurer la vraie taille du contenu
            container.style.height = '';
            container.style.minHeight = '';

            const h1 = panelNiveau1 ? panelNiveau1.scrollHeight : 0;
            const h2 = panelNiveau2 ? panelNiveau2.scrollHeight : 0;
            const H = Math.max(h1, h2) + getExtraSpace();

            container.style.height = H + 'px';
            container.style.minHeight = H + 'px';
          }

          function setHeightTo(el) {
            container.style.height = '';
            container.style.minHeight = '';

            const h = el ? el.scrollHeight : 0;
            const total = h + getExtraSpace();

            container.style.height = total + 'px';
            container.style.minHeight = total + 'px';
          }

          function buildSubHeader(titleText) {
            const header = document.createElement('div');
            header.className = 'mmc-subheader';

            const backBtn = document.createElement('button');
            backBtn.type = 'button';
            backBtn.className = 'mmc-back';
            backBtn.setAttribute('aria-label', 'Retour au menu principal');
            backBtn.setAttribute('title', 'Retour au menu principal');

            const title = document.createElement('div');
            title.className = 'mmc-title';
            title.setAttribute('role', 'heading');
            title.setAttribute('aria-level', '2');
            title.textContent = titleText || '';

            header.appendChild(backBtn);
            header.appendChild(title);

            backBtn.addEventListener('click', closeSub);
            return header;
          }

          function findSiblingUl(linkEl) {
            let ul = linkEl.nextElementSibling;
            while (ul && ul.tagName !== 'UL') {
              ul = ul.nextElementSibling;
            }
            return ul || null;
          }

          function openSub(linkEl) {
            activeToggleLink = linkEl;
            const ul = findSiblingUl(linkEl);
            if (!ul) return;

            panelNiveau2.innerHTML = '';

            const header = buildSubHeader((linkEl.textContent || '').trim());
            const clone = ul.cloneNode(true);

            clone.classList.add('mmc-level2');
            clone.style.removeProperty('display');

            Array.from(clone.children).forEach(function (li) {
              Array.from(li.children).forEach(function (child) {
                if (child.tagName === 'UL') {
                  child.classList.add('mmc-level3');
                  child.style.removeProperty('display');
                }
              });
            });

            panelNiveau2.appendChild(header);
            panelNiveau2.appendChild(clone);
            panelNiveau2.setAttribute('aria-hidden', 'false');

            lockHeightToMax();

            lastScrollPosition = container.scrollTop > 0 ? container.scrollTop : offcanvas.scrollTop;

            container.scrollTop = 0;
            offcanvas.scrollTop = 0;
            // ------------------------

            requestAnimationFrame(() => {
              void panelNiveau2.offsetHeight;
              requestAnimationFrame(() => {
                container.classList.add('mmc--subopen');

                mmcContainer.addEventListener('transitionend', function te(e) {
                  if (e.propertyName !== 'transform') return;
                  mmcContainer.removeEventListener('transitionend', te);
                  setHeightTo(panelNiveau2);

                  const back = panelNiveau2.querySelector('.mmc-back');
                  if (back) back.focus({ preventScroll: true });

                }, { once: true });
              });
            });

            const images = panelNiveau2.querySelectorAll('img');
            images.forEach(img => {
              img.addEventListener('load', () => {
                if (container.classList.contains('mmc--subopen')) {
                  setHeightTo(panelNiveau2);
                }
              }, { once: true });
            });
          }

          function closeSub() {
            panelNiveau2.setAttribute('aria-hidden', 'true');

            lockHeightToMax();

            container.scrollTop = lastScrollPosition;
            offcanvas.scrollTop = lastScrollPosition;

            requestAnimationFrame(() => {
              void panelNiveau2.offsetHeight;
              requestAnimationFrame(() => {
                container.classList.remove('mmc--subopen');
                mmcContainer.addEventListener('transitionend', function te(e) {
                  if (e.propertyName !== 'transform') return;
                  mmcContainer.removeEventListener('transitionend', te);
                  panelNiveau2.innerHTML = '';
                  setHeightTo(panelNiveau1);

                  if (activeToggleLink) {
                    activeToggleLink.focus({ preventScroll: true });
                  }

                }, { once: true });
              });
            });
          }

          function captureToggleClick(e) {
            const link = e.target.closest('a.toggle-menu');
            if (!link || !offcanvas.contains(link)) return;

            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') {
              e.stopImmediatePropagation();
            }

            ensureStructure();
            openSub(link);
          }

          if (!ensureStructure()) return;

          offcanvas.addEventListener('click', captureToggleClick, true);

          offcanvas.addEventListener('keydown', function (e) {
            const link = e.target && e.target.closest ? e.target.closest('a.toggle-menu') : null;
            if (!link) return;
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
              if (typeof e.stopImmediatePropagation === 'function') {
                e.stopImmediatePropagation();
              }
              ensureStructure();
              openSub(link);
            }
          }, true);

          setHeightTo(panelNiveau1);
          window.addEventListener('resize', () => {
            const active = container.classList.contains('mmc--subopen') ? panelNiveau2 : panelNiveau1;
            setHeightTo(active);
          });

          // Cela empêche le dernier élément d'être coupé quand la typographie s'ajuste sur mobile
          if (document.fonts) {
            document.fonts.ready.then(() => {
              window.dispatchEvent(new Event('resize'));
            });
          }
          // Pour les mobiles avec connexion lente
          setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
          setTimeout(() => window.dispatchEvent(new Event('resize')), 1500);
        });
      },
    };

    // Fermer le menu après le clic sur un lien d’ancre + Communication Iframe
    Drupal.behaviors.fermerMenuauClique = {
      attach: function (context) {
        const menuEl = document.getElementById('menuManuel');
        if (!menuEl) return;

        once('fermerMenuauClique-v2', '#menuManuel', context).forEach(() => {
          function isMobile() {
            return window.matchMedia('(max-width: 991px)').matches;
          }

          function getBs() {
            return bootstrap.Offcanvas.getInstance(menuEl) || new bootstrap.Offcanvas(menuEl);
          }

          function getAnchorIdFromHref(href) {
            if (!href) return null;
            if (href.startsWith('#') && href.length > 1) {
              return href.slice(1);
            }
            if (href.includes('#')) {
              let url;
              try { url = new URL(href, window.location.href); } catch (e) { return null; }
              if (url.origin !== window.location.origin) return null;
              if (url.pathname !== window.location.pathname) return null;
              return url.hash ? decodeURIComponent(url.hash.slice(1)) : null;
            }
            return null;
          }

          function handleActivate(e) {
            const link = e.target && e.target.closest ? e.target.closest('a') : null;
            if (!link || !menuEl.contains(link)) return;
            if (link.classList.contains('toggle-menu')) return;

            const id = getAnchorIdFromHref(link.getAttribute('href') || '');
            if (!id) return;

            window._ramqIframeTargetClicked = true;

            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') {
              e.stopImmediatePropagation();
            }

            // Demander le défilement à l'iframe
            const iframe = document.getElementById('manuel-iframe');
            if (iframe && iframe.contentWindow) {
              iframe.contentWindow.postMessage({ type: 'getOffset', target: '#' + id }, '*');
              try {
                history.replaceState(null, '', window.location.pathname + window.location.search + '#' + id);
              } catch (err) { }
            }

            if (isMobile()) {
              const bs = getBs();
              bs.hide();
            }
          }

          menuEl.addEventListener('click', handleActivate, true);
          menuEl.addEventListener('keydown', (e) => {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            handleActivate(e);
          }, true);
        });
      }
    };

    Drupal.behaviors.fixScrollOnTabToCloseButton = {
      attach: function (context) {
        const $menu = $("#menuManuel", context);

        if ($menu.length) {
          const $closeBtn = $menu.find(".btn-close").once("fix-scroll");

          if ($closeBtn.length) {
            $closeBtn.on("focus", function () {
              const scrollX = window.scrollX;
              const scrollY = window.scrollY;

              setTimeout(() => {
                window.scrollTo(scrollX, scrollY);
              }, 10);
            });
          }
        }
      }
    };

    Drupal.behaviors.manageOffcanvasAria = {
      attach: function (context) {
        const $menu = $("#menuManuel", context).once("aria-toggle");
        if ($menu.length) {
          $menu.on("shown.bs.offcanvas", function () {
            this.removeAttribute("aria-hidden");
          });

          $menu.on("hidden.bs.offcanvas", function () {
            this.setAttribute("aria-hidden", "true");
          });
        }
      }
    };

    // Recherche interne + proxy vers l'Iframe
    Drupal.behaviors.rechercheDansLeManuel = {
      attach: function (context) {
        const $sidebar = $("#menuManuel .offcanvas-body", context).once("in-page-search");
        const iframe = document.getElementById('manuel-iframe');
        if (!$sidebar.length || !iframe) return;

        const $searchBox = $(`
      <div class="recherche-interne mt-4">
        <label for="recherche-terme" class="form-label">Rechercher dans le contenu</label>
        <div class="recherche-input-wrap">
          <input type="text" id="recherche-terme" class="form-control mb-2" placeholder="Rechercher dans le manuel" />
          <button id="recherche-clear" type="button" class="btn-recherche-clear" aria-label="Effacer la recherche"></button>
          <button id="recherche-submit" type="button" class="btn-recherche" aria-label="Rechercher"></button>
        </div>
        <div class="resultats-navigation" style="display:none;">
          <span id="recherche-compteur" class="resultats-total text-muted"></span>
          <div class="btn-navigation">
            <button id="recherche-prev" type="button" aria-label="Précédent"></button>
            <button id="recherche-next" type="button" aria-label="Suivant"></button>
          </div>
        </div>
      </div>
    `);
        $sidebar.prepend($searchBox);

        const $input = $("#recherche-terme");
        const $clear = $("#recherche-clear");
        const $submit = $("#recherche-submit");
        const $navContainer = $(".resultats-navigation");
        const $counter = $("#recherche-compteur");
        const $prevBtn = $("#recherche-prev");
        const $nextBtn = $("#recherche-next");

        $clear.hide();

        const isMobile = window.matchMedia("(max-width: 991px)").matches;
        const offcanvasEl = document.getElementById("menuManuel");
        const bsOffcanvas = offcanvasEl ? (bootstrap.Offcanvas.getInstance(offcanvasEl) || new bootstrap.Offcanvas(offcanvasEl)) : null;

        function ensureSticky() {
          let $sticky = $("#recherche-sticky");
          if (!$sticky.length) {
            $sticky = $(`
          <div id="recherche-sticky" class="recherche-sticky" role="region" aria-live="polite">
            <div class="recherche-sticky-inner">
              <div class="recherche-sticky-controls"></div>
              <button id="recherche-close" type="button" class="btn btn-outline-dark btn-sm">
                Terminer la recherche
              </button>
            </div>
          </div>
        `).appendTo("body");
          }

          const $controls = $sticky.find(".recherche-sticky-controls");
          $navContainer.addClass("resultats-navigation-sticky").detach().appendTo($controls).show();

          $("#recherche-close").off("click").on("click", function () {
            if (iframe && iframe.contentWindow) iframe.contentWindow.postMessage({ type: 'searchClear' }, '*');
            if (bsOffcanvas) bsOffcanvas.show();
          });
        }

        function hideSticky() {
          const $sticky = $("#recherche-sticky");
          if ($sticky.length) {
            $navContainer.detach().appendTo($searchBox).removeClass("resultats-navigation-sticky").hide();
            $counter.text("");
            $sticky.remove();
          }
        }

        if (offcanvasEl) {
          offcanvasEl.addEventListener("show.bs.offcanvas", () => {
            if ($("#recherche-sticky").length) hideSticky();
          });
        }

        // Écouter les retours de la recherche de l'iframe
        if (!window.ramqSearchListenerAdded) {
          window.addEventListener("message", function (e) {
            if (e.data.type === "searchStatus") {
              const total = e.data.total;
              const current = e.data.current;

              if (total === 0) {
                $counter.text("Aucun résultat");
              } else {
                let limitTxt = e.data.truncated ? " (Limite atteinte)" : "";
                $counter.text(`${current} de ${total} résultats${limitTxt}`);

                if (isMobile && bsOffcanvas && offcanvasEl.classList.contains("show")) {
                  ensureSticky();
                  bsOffcanvas.hide();
                }
              }

              setTimeout(() => window.dispatchEvent(new Event('resize')), 50);
            }
          });
          window.ramqSearchListenerAdded = true;
        }

        $input.on("input", function () {
          const term = $input.val().trim();
          if (term.length > 0) $clear.show();
          else $clear.hide();
        });

        $input.on("keydown", function (e) {
          if (e.key === "Enter") {
            e.preventDefault();
            $submit.trigger("click");
          }
        });

        $clear.on("click", function () {
          $input.val("");
          $clear.hide();
          $input.trigger("focus");
          hideSticky();
          if (iframe && iframe.contentWindow) iframe.contentWindow.postMessage({ type: 'searchClear' }, '*');
        });

        $prevBtn.on("click", function () {
          if (iframe && iframe.contentWindow) iframe.contentWindow.postMessage({ type: 'searchPrev' }, '*');
        });

        $nextBtn.on("click", function () {
          if (iframe && iframe.contentWindow) iframe.contentWindow.postMessage({ type: 'searchNext' }, '*');
        });

        $submit.on("click", function () {
          const term = $input.val().trim();
          if (!term) return;
          $navContainer.show();
          $counter.text("Recherche en cours…");
          if (iframe && iframe.contentWindow) iframe.contentWindow.postMessage({ type: 'searchExecute', term: term }, '*');
        });
      }
    };

    // Désactiver le smooth scroll global lors du clic sur le bouton "Retour en haut" (Pour mobile)
    Drupal.behaviors.ramqManuelMobileBackToTop = {
      attach: function (context) {
        once('ramq-mobile-btt', 'body', context).forEach(function () {
          document.addEventListener('click', function (e) {
            const isBackToTop = e.target.closest('#backtotop, .back-to-top-js, .back-to-top, [id*="back-to-top"]');
            if (isBackToTop && window.innerWidth < 992) {
              e.preventDefault();
              e.stopPropagation();
              window.scrollTo({ top: 0, behavior: 'auto' });
            }
          }, true);
        });
      }
    };

    // Focus Trap pour le menu hors écran (Accessibilité)
    Drupal.behaviors.menuManuelFocusTrap = {
      attach: function (context) {
        const menuEl = document.getElementById("menuManuel");
        if (!menuEl) return;

        once("focus-trap-offcanvas", menuEl, context).forEach(function () {
          // Sélecteur pour tous les éléments interactifs possibles
          const focusableElementsString = 'a[href]:not([disabled]), button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

          menuEl.addEventListener('keydown', function (e) {
            // On ne s'intéresse qu'à la touche Tab
            if (e.key !== 'Tab' && e.keyCode !== 9) return;

            // Trouver tous les éléments "focusables" qui sont actuellement VISIBLES et VALIDES
            let focusableElements = Array.from(menuEl.querySelectorAll(focusableElementsString)).filter(function (el) {
              // Ignorer les éléments cachés nativement par aria-hidden
              if (el.closest('[aria-hidden="true"]')) return false;

              // Ignorer le Niveau 1 si le Niveau 2 est ouvert
              if (menuEl.querySelector('.mmc--subopen') && el.closest('.mmc-panel--niveau1')) return false;

              return (el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0) && window.getComputedStyle(el).visibility !== 'hidden';
            });

            if (focusableElements.length === 0) return;

            const firstTabStop = focusableElements[0];
            const lastTabStop = focusableElements[focusableElements.length - 1];

            // Trouver la position de l'élément actuellement focusé dans notre liste filtrée
            let currentIndex = focusableElements.indexOf(document.activeElement);

            // ON PREND LE CONTRÔLE TOTAL DU TAB (On annule l'action native du navigateur)
            e.preventDefault();

            // Si l'utilisateur fait Maj + Tab (vers l'arrière)
            if (e.shiftKey) {
              if (currentIndex === 0 || currentIndex === -1) {
                lastTabStop.focus(); // Boucle à la fin
              } else {
                focusableElements[currentIndex - 1].focus(); // Saute directement au précédent valide
              }
            }
            // Si l'utilisateur fait Tab (vers l'avant)
            else {
              if (currentIndex === focusableElements.length - 1 || currentIndex === -1) {
                firstTabStop.focus(); // Boucle au début
              } else {
                focusableElements[currentIndex + 1].focus(); // Saute directement au suivant valide
              }
            }
          });
        });
      }
    };

    /**
     * Gère l’ouverture et la fermeture du bloc des clientèles concernées
     * lorsque le nombre d’items dépasse 7.
     */
    Drupal.behaviors.actualiteClientelesToggle = {
      attach(context) {
        once('actualite-clienteles-toggle', '.actualite-clienteles__toggle', context).forEach((button) => {
          button.addEventListener('click', () => {
            const expanded = button.getAttribute('aria-expanded') === 'true';
            const nextExpanded = !expanded;
            const targetId = button.getAttribute('aria-controls');
            const content = document.getElementById(targetId);

            if (!content) {
              return;
            }

            button.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
            content.classList.toggle('is-open', nextExpanded);
            content.setAttribute('aria-hidden', nextExpanded ? 'false' : 'true');
          });
        });
      }
    };
})(jQuery, Drupal, drupalSettings, window);
